import { j as i } from "../../../../jsx-runtime.BREq8dyb.js";
import { memo as d } from "react";
import m, { PromiseState as o } from "../../../Loader/Loader.js";
import { useDataset as u } from "../../contexts/DatasetContext/DatasetContext.js";
import "../../contexts/FeatureContext/FeatureContext.js";
import "../../contexts/FileContext/FileContext.js";
import "../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../contexts/NavigatorContext/NavigatorContext.js";
import "../../contexts/OptionsContext/OptionsContext.js";
import "../../contexts/SchemaContext/SchemaContext.js";
import "../../contexts/TypificationContext/TypificationContext.js";
import "../../contexts/WorkerContext/WorkerContext.js";
const n = d(() => {
  const {
    afterUploadResults: t,
    beforeUploadResults: a,
    uploadError: e,
    uploading: s,
    uploadLabel: l,
    uploadProgress: p,
    uploadResult: r
  } = u();
  return /* @__PURE__ */ i.jsx(m, { LoadProgressBarAndLabelAndProgressPercentageProps: {
    sx: {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      width: "clamp(0px, 16rem, 100%)"
    }
  }, LoadProgressPercentageProps: {
    sx: {
      "& .value": {
        fontSize: "inherit !important"
      }
    }
  }, loadLabel: l, loadProgress: p, loadResult: e || (r ? null : void 0), loadResults: [...a || [], ...t || []], loadState: s ? o.Pending : e ? o.Rejected : r ? o.Fulfilled : void 0 });
});
n.displayName = "Reporter";
export {
  n as default
};
//# sourceMappingURL=Reporter.js.map
